import { formatMessageTime } from '../utils/dateHelpers';

interface MessageBubbleProps {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
  isFirstUnread?: boolean;
}

const MessageBubble = ({ role, content, timestamp, isFirstUnread }: MessageBubbleProps) => {
  const isBusinessOwner = role === 'assistant';
  
  return (
    <div className="px-4 py-2">
      {isFirstUnread && (
        <div className="flex items-center justify-center mb-3">
          <div className="bg-blue-100 text-blue-700 text-xs font-medium px-3 py-1 rounded-full">
            הודעות חדשות ↓
          </div>
        </div>
      )}
      
      <div className={`flex ${isBusinessOwner ? 'justify-end' : 'justify-start'}`}>
        <div
          className={`max-w-[75%] rounded-lg px-3 py-2 shadow-sm ${
            isBusinessOwner
              ? 'bg-[#dcf8c6] text-gray-900 rounded-br-none'
              : 'bg-white text-gray-900 rounded-bl-none'
          }`}
        >
          <p className="text-sm whitespace-pre-wrap break-words">{content}</p>
          <div className={`flex items-center justify-end mt-1 gap-1`}>
            <span className="text-[10px] text-gray-500">{formatMessageTime(timestamp)}</span>
            {isBusinessOwner && (
              <svg className="w-4 h-4 text-blue-500" viewBox="0 0 16 16" fill="currentColor">
                <path d="M11.071 1.929a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1 0 .708l-7.5 7.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 0 1 0-.708l7.5-7.5zm-.708 1.414L3.5 10.207l2.793 2.793 6.864-6.864-2.794-2.793z"/>
                <path d="M7.5 14.5a.5.5 0 0 1-.5-.5V13a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5zm-3-3a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5z"/>
              </svg>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
